import React,
{
  ReactElement, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { refreshLegacyToken, refreshToken } from 'reducers/UserInfo';
import { useQueryParam } from 'use-query-params';
import { useHistory } from 'react-router-dom';
import LoadingOverlay from 'components/LoadingOverlay';

function IconRedirect(): ReactElement {
  const [jwt] = useQueryParam<string>('jwt');
  const [redirectTo] = useQueryParam<string>('redirectTo');
  const [token] = useQueryParam<string>('refresh_token');
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;
    const targetPath = redirectTo ?? '/';

    const redirectToLogin = (): void => {
      if (isMounted) {
        history.push(`/login?redirectTo=${targetPath}`);
      }
    };

    const redirectToTarget = async (): Promise<void> => {
      if (!jwt) {
        redirectToLogin();
        return;
      }

      dispatch(refreshToken(jwt));

      try {
        if (token) {
          await dispatch(refreshLegacyToken(token));
        }

        if (isMounted) {
          history.push(targetPath);
        }
      } catch {
        redirectToLogin();
      }
    };

    redirectToTarget();

    return () => {
      isMounted = false;
    };
  }, [dispatch, history, jwt, redirectTo, token]);

  return (
    <LoadingOverlay isVisible loadingText="Redirecting to Icon..." />
  )
}

export default IconRedirect;
